import { SettingsValueProps } from './components/settings/type';
// routes
import { PATH_DASHBOARD } from './routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1';

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

export const MAPBOX_API = process.env.REACT_APP_MAPBOX;

// export const PathAfter = () => {
//   if (MODULES('WEBSITE_MODULE')) {
//     return PATH_DASHBOARD.website.bookAssessments;
//   }
//   if (MODULES('APPOINTMENT_MODULE')) {
//     return PATH_DASHBOARD.website.appointments;
//   }
//   if (MODULES('JOBS_MODULE')) {
//     return PATH_DASHBOARD.website.departments;
//   }
//   if (MODULES('BULK_SMS_MODULE')) {
//     return PATH_DASHBOARD.website.sms;
//   }
//   if (MODULES('NEWSLATTER_MODULE')) {
//     return PATH_DASHBOARD.website.newsletter;
//   }
//   return PATH_DASHBOARD.website.bookAssessments;
// };

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN =  PATH_DASHBOARD.website.bookAssessments
// export const PATH_AFTER_LOGIN = () => {
//   console.log("lllllllllllllllllllllsss",PathAfter())
//   return PathAfter();
// }; 
// as '/dashboard/app'
// export const PATH_AFTER_LOGIN =
//   (MODULES('WEBSITE_MODULE') && PATH_DASHBOARD.website.bookAssessments) ||
//   (MODULES('WEBSITE_MODULE') && PATH_DASHBOARD.website.serviceRequests) ||
//   (MODULES('WEBSITE_MODULE') && PATH_DASHBOARD.website.callbackRequests) ||
//   (MODULES('WEBSITE_MODULE') && PATH_DASHBOARD.website.subscribers) ||
//   (MODULES('WEBSITE_MODULE') && PATH_DASHBOARD.website.contacts) ||
//   (MODULES('APPOINTMENT_MODULE') && PATH_DASHBOARD.website.appointments) ||
//   (MODULES('APPOINTMENT_MODULE') && PATH_DASHBOARD.website.clients) ||
//   (MODULES('WEBSITE_MODULE') && PATH_DASHBOARD.website.sms) ||
//   (MODULES('JOBS_MODULE') && PATH_DASHBOARD.website.departments) ||
//   (MODULES('JOBS_MODULE') && PATH_DASHBOARD.website.jobs) ||
//   (MODULES('JOBS_MODULE') && PATH_DASHBOARD.website.jobRoles);

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1';

// SETTINGS
// Please remove `localStorage` when you set settings.
// ----------------------------------------------------------------------

export const defaultSettings: SettingsValueProps = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeColorPresets: 'default',
  themeLayout: 'horizontal',
  themeStretch: false,
};
